import { Component, Story, Knobs, Accents } from './DocTypes';

const knobs: Knobs = {
  'colour-scheme': {
    editor: 'dropdown',
    editorOptions: ['light', 'dark', 'default', ''],
    default: '',
  },
  device: {
    editor: 'dropdown',
    editorOptions: ['mobile', 'desktop', ''],
    default: '',
  },
  disabled: {
    default: false,
    editor: 'checkbox',
  },
  checked: {
    default: false,
    editor: 'checkbox',
  },
  size: {
    editor: 'dropdown',
    editorOptions: ['normal', 'large'],
    default: 'normal',
  },
  label: {
    editor: 'textbox',
    default: 'Tag3 Switch',
  },
  labelPlacement: {
    editor: 'dropdown',
    editorOptions: ['left', 'top', 'right', 'bottom'],
    default: 'right',
  },
  name: {
    editor: 'textbox',
    default: 'Switch1',
  },
  labelStyle: {
    editor: 'textbox',
    default: '',
  },
  type: {
    editor: 'dropdown',
    editorOptions: ['rounded', 'squared', ''],
    default: '',
  },
  accent: {
    default: 'black',
    editor: 'dropdown',
    editorOptions: [''].concat(Accents),
  },
};

const BasicStory: Story = {
  title: 'Basic',
  description: 'A basic switch',

  coreComponent_v3: {
    html: `<tag3-switch{{...knobs}}>
</tag3-switch>
`,
    knobs: knobs,
  },
  reactWrapper_v3: {
    jsx: `<Tag3Switch{{...knobs}}> </Tag3Switch>`,
    knobs: {
      ...knobs,
      labelStyle: { ...knobs.labelStyle, qualifierStart: '{', qualifierEnd: '}' },
    },
  },
};

export const TagSwitchDocs: Component = {
  type: 'component',
  name: 'switch',
  description: 'Renders a switch',
  mobileFriendly: false,
  popular: false,
  preRelease: '',
  props: [
    {
      name: 'colourScheme',
      description:
        'Dark mode (theme) control. Default for normal browser driven control. Dark | Light to force respective styling regardless of browser setting.',
      type: 'dark | light | default',
      default: 'light',
    },
    {
      name: 'device',
      description: 'Set preferred styling theme for device type.',
      type: 'desktop | mobile',
      default: 'desktop',
    },
    {
      name: 'disabled',
      description: 'Whether the switch is disabled',
      type: 'boolean',
    },
    {
      name: 'checked',
      description: 'Whether the switch is checked',
      type: 'boolean',
    },
    {
      name: 'size',
      description: 'Size of the switch',
      type: 'normal | large',
      default: 'normal',
    },
    {
      name: 'label',
      description: 'Label of the switch',
      type: 'string',
      default: '',
    },
    {
      name: 'labelPlacement',
      description: 'Location of the label',
      type: 'top | bottom | left | right',
      default: 'end',
    },
    {
      name: 'type',
      description: 'Change the type of the switch',
      type: 'rounded | squared',
      default: 'rounded',
    },
    {
      name: 'accent',
      description: 'The accent of the selected day.',
      type: 'Accent',
    },
    {
      name: 'name',
      description: 'Switch name, that is emitted in the switchClick event',
      type: 'string',
    },
    {
      name: 'labelStyle',
      description: 'JSX style object in JSON to apply to the label',
      type: 'string',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'switchValueChange',
      description: 'Triggers when the toggle is switched changes',
      parameters: [{ name: 'value', description: 'The selected value', type: 'string' }],
    },
  ],
  methods: [],
  stories: [BasicStory],
};
